import {
  AnyPartType,
  partTypeAccessory,
  partTypePackage,
  partTypeTire,
  partTypeWheel,
} from "../constants/partTypes";
import {
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../constants/productTypes";

const map = {
  [productTypeAccessory]: partTypeAccessory,
  [productTypePackage]: partTypePackage,
  [productTypeTire]: partTypeTire,
  [productTypeWheel]: partTypeWheel,
};

export const productTypeToPartType = (
  productType?: null | string
): AnyPartType | null => {
  return (map[productType as keyof typeof map] as AnyPartType) || null;
};
